const React = require('react');
const PropTypes = require('prop-types');

const NoUserBox = require('./NoUserBox');
const UserNotInvestedBox = require('./UserNotInvestedBox');
const UserInvestedBox = require('./UserInvestedBox');

require('./UserFundBox.scss');


const UserFundBox = ({ fund, investment, user, onlyOneFundWithSameIsin, location, isAlternativeFund, immFeatureFlags, brokerMyInvestments }) => (
    <div className="user-fund-box">
        {
            user
                ? investment
                    ? <UserInvestedBox brokerMyInvestments={brokerMyInvestments} immFeatureFlags={immFeatureFlags} investment={investment} fund={fund} location={location} onlyOneFundWithSameIsin={onlyOneFundWithSameIsin} isAlternativeFund={isAlternativeFund} />
                    : <UserNotInvestedBox fund={fund} isAlternativeFund={isAlternativeFund} />
                : <NoUserBox fund={fund} />
        }
    </div>
);


UserFundBox.propTypes = {
    fund: PropTypes.object.isRequired,
    investment: PropTypes.object,
    immFeatureFlags: PropTypes.object,
    brokerMyInvestments: PropTypes.object,
    user: PropTypes.object,
    onlyOneFundWithSameIsin: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    isAlternativeFund: PropTypes.bool
};


module.exports = UserFundBox;
